import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import '@flaticon/flaticon-uicons/css/solid/straight.css';
import Box from '@mui/material/Box';

export const FlatIconOptions = Object.freeze({
  abort: 'undo',
  // seta para trás
  // utilizado em botões voltar/cancelar
  // https://www.flaticon.com/free-icon-font/undo_3917161?page=1&position=2&term=undo&origin=search&related_id=3917161
  approve: 'social-network',
  reprove: 'social-network',
  // like/deslike
  // utilizado em botões aprovar/reprovar
  // https://www.flaticon.com/free-icon-font/social-network_3916586?page=1&position=3&term=social-network&origin=search&related_id=3916586
  clear: 'eraser',
  // borracha
  // utilizado nos endAdornment para limpar o campo
  // https://www.flaticon.com/free-icon-font/eraser_10435910?page=1&position=1&term=eraser&origin=search&related_id=10435910
  filter: 'filter',
  // filtro
  // utilizado em botões de filtro
  // https://www.flaticon.com/free-icon-font/filter_3914366?page=1&position=1&term=filter&origin=search&related_id=3914366
  clearFilter: 'clear-alt',
  // filtro com um x
  // utilizado em botões para limpar filtros
  // https://www.flaticon.com/free-icon-font/clear-alt_13087973?page=1&position=1&term=clear-alt&origin=search&related_id=13087973
  next: 'angle-right',
  back: 'angle-left',
  new: 'plus',
  save: 'disk',
  edit: 'pencil',
  delete: 'trash',
  search: 'search',
  settings: 'settings',
  calendarBlock: 'calendar-xmark',
  refuse: 'ban',
  refresh: 'refresh',
  sentEmail: 'newsletter-subscribe',
  notes: 'comment-alt',
  confirm: 'check',
  first: 'first',
  last: 'last',
  close: 'cross',
  openKeyboard: 'keyboard-down',
  keyboard: 'keyboard',
  restart: 'eraser',
  receiving: 'truck-arrow-left',
  shipping: 'truck-arrow-right',
  dashboard: 'dashboard-monitor',
  quickSearch: 'magnifying-glass-wave',
  layers: 'layers',
  stock: 'boxes',
  product: 'box-open-full',
  sales: 'chart-mixed-up-circle-dollar',
  resupplies: 'restock',
  inventory: 'inboxes',
  stockTransfer: 'exchange',
  reports: 'document',
  system: 'wrench-alt',
  menuSubItem: 'arrow-turn-down-right',
  exit: 'exit',
  expand: 'angle-down',
  collapse: 'angle-up',
  news: 'megaphone',
  help: 'interrogation',
  menu: 'menu-burger',
  noshow: 'time-delete',
  fullscreen: 'screen',
  copy: 'copy-alt',
  cloudUpload: 'cloud-upload-alt',
  cancelled: 'cross-circle',
  pending: 'clock-three',
  box: 'box-alt',
  visible: 'eye',
  noVisible: 'eye-crossed',
  picking: 'box-open',
  packing: 'box-open-full',
  dispatch: 'box-circle-check',
  shippingStatus: 'triangle-warning',
  shippingStatusCheck: 'check',
  saleIntegrationStatusCheck: 'check-circle',
  saleIntegrationStatusError: 'cross-circle',
  saleIntegrationStatusInProgress: 'circle-half-stroke',
  timerAdd: 'time-add',
  timerCheck: 'time-check',
  actions: 'menu-dots',
  warning: 'octagon-exclamation',
  inPicking: 'user-check',
  print: 'print',
  history: 'time-past',
  priority: 'priority-importance',
  import: 'file-import',
  quantityRequested: 'shopping-cart',
  quantityServed: 'shopping-cart-check',
  pulmao: 'lungs',
  person: 'user',
});

const FlatIcon = ({
  icon,
  size = '16px',
  strokeCorner = 'rr',
  onClick,
  style,
  rotate,
  invertHorizontally,
  invertVertically,
  marginRight = '5px',
}) => {
  if (!icon || !Object.values(FlatIconOptions).includes(icon)) {
    console.warn(`Ícone inválido: ${icon}`);
    return null;
  }

  let transform = `scale(${invertHorizontally ? '-1' : '1'}, ${invertVertically ? '-1' : '1'})`;

  if (icon === 'first') {
    return (
      <Box
        onClick={onClick}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          fontSize: `${size}`,
          marginTop: !invertVertically ? '5px' : '',
          rotate: `${rotate ?? ''}`,
          transform: `${transform}`,
          ...style,
        }}>
        <i className={`fi fi-rr-tally-1`} />
        <i
          className={`fi fi-rr-angle-left`}
          style={{ marginLeft: '-18px' }}
        />
      </Box>
    );
  }

  if (icon === 'last') {
    return (
      <Box
        onClick={onClick}
        style={{
          ...style,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          fontSize: `${size}`,
          marginTop: !invertVertically ? '5px' : '',
          rotate: `${rotate ?? ''}`,
          transform: `${transform}`,
        }}>
        <i
          className={`fi fi-rr-angle-right`}
          style={{ marginRight: '-3px' }}
        />
        <i className={`fi fi-rr-tally-1`} />
      </Box>
    );
  }

  return (
    <i
      className={`fi fi-${strokeCorner}-${icon}`}
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: `${size}`,
        lineHeight: 1,
        marginRight: marginRight,
        rotate: `${rotate ?? ''}`,
        transform: `${transform}`,
        ...style,
      }}
    />
  );
};

export default FlatIcon;
